import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import { Modal } from "components/ui"
import CardHorizontal from "components/TypeCard/CardHorizontal"

export default function App(props) {
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const { status, id, type, is_live, is_protected } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/channel?id=${id}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/channel?id=${id}`)
    }
  }, [signKey])

  if (status === "live" || !is_live) {
    return (
      <>
        <div onClick={onClick}>
          <CardHorizontal {...props} nextLink={`/channel?id=${id}&type=${type}`} hideText={true} />
        </div>
        {/* <Modal
          isOpen={isModal}
          onCancel={() => {
            setIsModal(false)
          }}
          showIcon={false}
        >
          <LoginAlert
            onCancel={() => {
              setIsModal(false)
            }}
            onNext={onNext}
          />
        </Modal> */}
      </>
    )
  } else {
    return <CardHorizontal {...props} nextLink={`/channel?id=${id}&type=${type}`} hideText={true} />
  }
}
